import React, {
  memo,
  ReactElement,
  useEffect,
  useRef,
  useState,
  useCallback,
} from 'react';
import { APIProvider, Map, Marker } from '@vis.gl/react-google-maps';
import { Skeleton } from '@mui/material';

export const MapGoogle = ({ coordinates, address }) => {
  const [loading, setLoading] = useState(false);
  const position = { lat: 53.54992, lng: 10.00678 };
  const [markerPosition, setMarkerPosition] = useState(undefined);
  const fetchCoordinates = async (address) => {
    setLoading(true);

    const response = await fetch(
      `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(
        address
      )}`
    );
    const data = await response.json();

    if (data && data.length > 0) {
      setMarkerPosition({
        lat: parseFloat(data[0].lat),
        lng: parseFloat(data[0].lon),
      });
    } else {
      setMarkerPosition(undefined);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (address?.coordinates) {
      setLoading(true);
      const coordinates = address.coordinates.split(',');
      setMarkerPosition({
        lat: parseFloat(coordinates[0]),
        lng: parseFloat(coordinates[1]),
      });

      setTimeout(() => {
        setLoading(false);
      }, 1000);
    } else {
      fetchCoordinates(address?.address_line1);
    }
  }, [address]);

  return (
    <>
      {loading ? (
        <>
          <Skeleton sx={{}} variant="rounded" width={'100%'} height={300} />
        </>
      ) : (
        <>
          {markerPosition && (
            <>
              <APIProvider apiKey={'AIzaSyDkdzK-tyP023Zsvu_JnsvNK_PFz5nJjXQ'}>
                <Map
                  defaultCenter={markerPosition}
                  defaultZoom={14}
                  style={{
                    height: '300px',
                  }}
                >
                  <Marker position={markerPosition} />
                </Map>
              </APIProvider>
            </>
          )}
        </>
      )}
    </>
  );
};
